import React from 'react'
import { arrayOf, shape, string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import SectionTitle from 'components/atoms/SectionTitle'

import TestimonyCard from 'components/molecules/TestimonyCard'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config

const srcSetTopBg = [
  {
    media: '(min-width: 768px)',
    srcset: `${assetsUrl}/assets/img/bg-top-pc.svg`,
  },
]

const srcSetBottomBg = [
  {
    media: '(min-width: 768px)',
    srcset: `${assetsUrl}/assets/img/bg-bottom-pc.svg`,
  },
]

const ScholarshipTestimonies = ({ title, testimonies }) => {
  const testimonyItems = testimonies && testimonies.map((testimony, idx) => (
    <Col className="scholarship-testimonies__col" md="6" key={`apttestimony-card-${idx}`}>
      <TestimonyCard
        direction="row"
        {...testimony}
        img={testimony.img}
      />
    </Col>
  ))
  return (
    <div id="testimonies" className="scholarship-testimonies">
      <Relazsizes
        el="picture"
        dataSrc={`${assetsUrl}/assets/img/bg-top-sp.svg`}
        dataSrcset={srcSetTopBg}
        className="scholarship-testimonies__bg-top"
      />
      <SectionContainer
        paddingTop={120}
        paddingBottom={120}
        backgroundColor="#bcefe2"
      >
        <Container>
          <SectionTitle title={title || 'Testimoni'} />
          <Row>
            {testimonyItems}
          </Row>
        </Container>
      </SectionContainer>
      <Relazsizes
        el="picture"
        dataSrc={`${assetsUrl}/assets/img/bg-bottom-sp.svg`}
        dataSrcset={srcSetBottomBg}
        className="scholarship-testimonies__bg-bottom"
      />
      <style jsx>
        {`
          .scholarship-testimonies {
            position: relative;

            @media screen and (min-width: 768px) {
              padding-top: 40px;
            }
            :global(&__bg-top) {
              width: 100%;
              top: -1%;
              position: absolute;
            }
            :global(&__bg-bottom) {
              width: 100%;
              top: 99%;
              position: absolute;
              @media screen and (min-width: 768px) {
                top: 95%;
              }
            }
            :global(.campus-section) {
              background-image: url('${assetsUrl}/assets/img/bubble-top-right.svg'), url('${assetsUrl}/assets/img/bubble-top-left.svg'), url('${assetsUrl}/assets/img/bubble-bottom-left.svg');
              background-repeat: no-repeat;
              background-position: top 0 right 0, top 10% left 5%, bottom 10% left 0;
            }
            :global(.testimony) {
              height: 100%;
            }
          }
        `}
      </style>
    </div>
  )
}

const testimonyShape = shape({
  img: string,
  name: string,
  imgAlt: string,
  schoolName: string,
  majorName: string,
  testimony: string,
})

ScholarshipTestimonies.propTypes = {
  title: string,
  testimonies: arrayOf(testimonyShape),
}

ScholarshipTestimonies.defaultProps = {
  title: 'Testimoni',
}

export default ScholarshipTestimonies
